module.exports = __webpack_public_path__ + "static/media/index.225370fc.less";